import React from 'react'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { clsx } from 'clsx'
import * as _ from 'underscore'

type ManagerNavigationProps = {
  title: string
  allowedRoles: string[]
  menuItems: {
    name: string
    to?: string
    href?: string
    initial: string
    allowedRoles: string[]
  }[]
}

const ManagerNavigation = ({ title, allowedRoles, menuItems }: ManagerNavigationProps) => {
  const { user } = useSelector((state: RootState) => state.app)
  const location = useLocation()
  if (_.intersection(allowedRoles, user.roles).length === 0) {
    return <></>
  }
  return (
    <React.Fragment>
      <div className="text-xs font-semibold leading-6 text-gray-400">{title}</div>
      <ul role="list" className="-mx-2 mt-2 space-y-1">
        {menuItems.map((oneMenuItem) => {
          if (!_.intersection(oneMenuItem.allowedRoles, user.roles)) {
            return null
          }
          return (
            <li key={oneMenuItem.name}>
              {oneMenuItem.to ? (
                <Link
                  to={oneMenuItem.to}
                  className={clsx(
                    oneMenuItem.to === location.pathname
                      ? 'bg-gray-800 text-white'
                      : 'text-gray-400 hover:text-white hover:bg-gray-800',
                    'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                  )}
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800 text-[0.625rem] font-medium text-gray-400 group-hover:text-white">
                    {oneMenuItem.initial}
                  </span>
                  <span className="truncate">{oneMenuItem.name}</span>
                </Link>
              ) : (
                <a
                  href={oneMenuItem.href}
                  className={clsx(
                    'text-gray-400 hover:text-white hover:bg-gray-800',
                    'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                  )}
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800 text-[0.625rem] font-medium text-gray-400 group-hover:text-white">
                    {oneMenuItem.initial}
                  </span>
                  <span className="truncate">{oneMenuItem.name}</span>
                </a>
              )}
            </li>
          )
        })}
      </ul>
    </React.Fragment>
  )
}

export default ManagerNavigation
